import { PinFieldDisplay } from 'components/Field/PinFieldDisplay';
import { useSelector } from 'hooks/useSelector';
import { pureComponent } from 'lib/pureComponent';
import React from 'react';
import { useDispatch } from 'react-redux';
import { doAseLoadPlans } from 'store/assessments/actions';
import { selectAseAssetPlan } from 'store/assessments/selectors';
import { PinNew } from 'store/plan/types';

interface Props {
  pin: PinNew | undefined;
}

export const PinDisplayRowAssessment: React.FC<Props> = pureComponent(
  ({ pin }) => {
    const dispatch = useDispatch();

    const plan = useSelector((state) =>
      selectAseAssetPlan(state, pin ? pin.planId : '-1'),
    );

    return (
      <PinFieldDisplay
        pin={plan ? pin : undefined}
        plan={plan}
        onPress={
          plan && pin
            ? () =>
                dispatch(
                  doAseLoadPlans({
                    // plans: { [plan.id]: plan },
                    pin,
                    pins: [],
                  }),
                )
            : undefined
        }
      />
    );
  },
);
